import { css } from 'lit';
import componentStyles from '../styles/component.styles';
export default css `
  ${componentStyles}

  /* mf-ai-badge and the tooltip inside it read mfui's --mf-* tokens, which the
     portal never defines — mediaflow-ui/style.css is an admin-only stylesheet.
     Bridge the ones they use so the badge follows the portal design instead of
     falling back to unset colours. */
  mf-ai-badge {
    --mf-text: var(--p-text-color);
    /* The mark keeps --mf-text; --mf-text-light is the label beside it */
    --mf-text-light: var(--p-text-color-meta);
    --mf-bg-100: var(--p-bg-light);
    --mf-border: var(--p-border);
    --mf-blue: var(--p-focus);
    --mf-fs-small: var(--p-font-size-small);
    /* Tooltip surface, reusing the portal's own dark pairing */
    --mf-bg-reverse-200: var(--p-bg-dark);
    --mf-bg: var(--p-text-color-light);
  }

  :host([dark]) mf-ai-badge {
    --mf-text: var(--p-text-color-light);
    --mf-text-light: var(--p-text-color-light-meta);
    --mf-bg-100: var(--p-bg-dark);
    --mf-border: var(--p-text-color-light-contrast-300);
  }
`;
